import React from 'react'
import {
  FaBuilding,
  FaCalendarAlt,
  FaShoppingCart,
  FaMoneyBillWave,
  FaChartLine,
  FaHandHoldingUsd,
} from 'react-icons/fa'
import { Link } from 'react-router-dom'

const CompanyProfileSection = ({
  brandName,
  companyLogoUrl,
  companyName,
  ebitda,
  grossRevenue,
  industry,
  netProfitLoss,
  yearIncorporation,
  id,
}) => {
  return (
    <>
      <div className="max-w-2xl mx-auto bg-slate-100 border-2 border-slate-300 border-t-0 rounded-b-lg p-5 h-auto">
        {/* Header */}
        <div className="flex items-end gap-2 mb-2">
          <img
            src={companyLogoUrl}
            alt={brandName}
            className="w-[35px] h-[35px] rounded object-cover object-center"
          />
          <h2 className="text-orange-700 align-bottom text-xl md:text-base lg:text-3xl whitespace-nowrap font-aptos-bold">
            {brandName}
          </h2>
        </div>

        <hr className="border-t-2 border-[#ff7010] w-full mb-7" />

        {/* Responsive Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-6 gap-y-6 text-sm">
          {/* Company Name */}
          <div className="flex gap-2">
            <FaBuilding size={18} className="text-[#ff7010] mt-1 shrink-0" />
            <div>
              <p className="text-gray-500 font-aptos-regular">Company Name</p>
              <p className="font-aptos-bold">{companyName}</p>
            </div>
          </div>

          {/* Incorporation Year */}
          <div className="flex gap-2">
            <FaCalendarAlt size={18} className="text-[#ff7010] mt-1 shrink-0" />
            <div>
              <p className="text-gray-500 font-aptos-regular">
                Incorporation Year
              </p>
              <p className="font-aptos-bold">{yearIncorporation}</p>
            </div>
          </div>

          {/* Industry */}
          <div className="flex gap-2">
            <FaShoppingCart
              size={18}
              className="text-[#ff7010] mt-1 shrink-0"
            />
            <div>
              <p className="text-gray-500 font-aptos-regular">Industry</p>
              <p className="font-aptos-bold">{industry}</p>
            </div>
          </div>

          {/* Gross Revenue */}
          <div className="flex gap-2">
            <FaMoneyBillWave
              size={18}
              className="text-[#ff7010] mt-1 shrink-0"
            />
            <div>
              <p className="text-gray-500 font-aptos-regular">Gross Revenue</p>
              {grossRevenue &&
                (() => {
                  const start = grossRevenue.indexOf('(')
                  const end = grossRevenue.indexOf(')')

                  // Main value (before parentheses)
                  const value = grossRevenue.slice(0, start).trim()
                  // Year with parentheses
                  const year = grossRevenue.slice(start, end + 1)

                  return (
                    <>
                      <p className="font-aptos-bold">{value}</p>
                      <p className="font-aptos-bold">{year}</p>
                    </>
                  )
                })()}
            </div>
          </div>

          {/* EBITDA */}
          <div className="flex gap-2">
            <FaChartLine size={18} className="text-[#ff7010] mt-1 shrink-0" />
            <div>
              <p className="text-gray-500 font-aptos-regular">EBITDA</p>

              {ebitda &&
                (() => {
                  const start = ebitda.indexOf('(')
                  const end = ebitda.indexOf(')')

                  // Main value (before parentheses)
                  const value = ebitda.slice(0, start).trim()
                  // Year with parentheses
                  const year = ebitda.slice(start, end + 1)

                  return (
                    <>
                      <p
                        className={`${
                          ebitda.charAt(0) === '+'
                            ? 'text-green-700'
                            : 'text-red-600'
                        }  font-aptos-bold`}
                      >
                        {value.charAt(0) === '+' ? value.slice(1) : value}
                      </p>
                      <p className="font-aptos-bold">{year}</p>
                    </>
                  )
                })()}
            </div>
          </div>

          {/* Net Profit */}
          <div className="flex gap-2">
            <FaHandHoldingUsd
              size={20}
              className="text-[#ff7010] mt-1 shrink-0"
            />
            <div>
              <p className="text-gray-500 font-aptos-regular">
                Net Profit/(Loss)
              </p>
              {netProfitLoss &&
                (() => {
                  const start = netProfitLoss.indexOf('(')
                  const end = netProfitLoss.indexOf(')')

                  // Main value (before parentheses)
                  const value = netProfitLoss.slice(0, start).trim()
                  // Year with parentheses
                  const year = netProfitLoss.slice(start, end + 1)

                  return (
                    <>
                      <p
                        className={`${
                          netProfitLoss.charAt(0) === '+'
                            ? 'text-green-700'
                            : 'text-red-600'
                        }  font-aptos-bold`}
                      >
                        {value.charAt(0) === '+' ? value.slice(1) : value}
                      </p>
                      <p className="font-aptos-bold">{year}</p>
                    </>
                  )
                })()}
            </div>
          </div>
          <Link
            to="/dealdashboard/add/graph"
            state={{ graphId: id, edit: true }}
            className="text-center bg-[#ff7010] py-2 rounded text-white font-aptos-bold"
          >
            Update
          </Link>
        </div>
      </div>
    </>
  )
}

export default CompanyProfileSection
